import { CustomColorsUtils } from '@space-lib/utils/colors'
import { HEX_LENGTH, TWENTY_PERCENT_ALPHA_HEX } from '@space-lib/utils/colors/constants'

import { dark } from './dark'
import { FixedColorsHex, ThemeMode } from './enum'
import { Colors, ColorsTypes } from './enum'
import { light } from './light'

class CustomColors {
  static switchColors(value: string, custom: ColorsTypes, theme: ThemeMode) {
    const valueColor = this.transformValue(value)

    if (custom === ColorsTypes.LIGHTEST) {
      return this.lightestColors(valueColor, theme)
    }

    if (custom === ColorsTypes.LIGHTER) {
      return this.lighterColors(valueColor, theme)
    }

    if (custom === ColorsTypes.LIGHT) {
      return this.lightColors(valueColor, theme)
    }

    if (custom === ColorsTypes.NORMAL) {
      return this.normalColors(valueColor)
    }

    if (custom === ColorsTypes.DARK) {
      return this.darkColors(valueColor, theme)
    }

    if (custom === ColorsTypes.DARKER) {
      return this.darkerColors(valueColor, theme)
    }

    if (custom === ColorsTypes.DARKEST) {
      return this.darkestColors(valueColor, theme)
    }

    return
  }

  static lightestColors(value: string, theme: ThemeMode) {
    if (value.includes('#')) {
      return `${value}`
    }
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.lightest

    return dark.colors.custom[value]?.lightest
  }

  static lighterColors(value: string, theme: ThemeMode) {
    if (value.includes('#')) {
      return `${value.slice(0, HEX_LENGTH)}${TWENTY_PERCENT_ALPHA_HEX}`
    }
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.lighter

    return dark.colors.custom[value]?.lighter
  }

  static lightColors(value: string, theme: ThemeMode) {
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.light

    return dark.colors.custom[value]?.light
  }

  static darkColors(value: string, theme: ThemeMode) {
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.dark

    return dark.colors.custom[value]?.dark
  }

  static darkerColors(value: string, theme: ThemeMode) {
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.darker

    return dark.colors.custom[value]?.darker
  }

  static darkestColors(value: string, theme: ThemeMode) {
    if (theme === ThemeMode.LIGHT) return light.colors.custom[value]?.darkest

    return dark.colors.custom[value]?.darkest
  }

  static normalColors(value: string) {
    if (value.includes('#')) {
      return `${value}`
    }

    return dark.colors.custom[value]?.normal
  }

  static transformValue(value: string) {
    let tempValue = value

    if (CustomColorsUtils.isFixedColor(value)) {
      if (value.includes('#')) {
        tempValue = FixedColorsHex[value] === Colors.GRAY ? 'default' : FixedColorsHex[value]
      } else {
        tempValue = Colors[value]
      }
    }
    if (!value || value === Colors.GRAY) {
      tempValue = 'default'
    }

    return tempValue.toLocaleLowerCase()
  }
}

export default CustomColors
